module.exports = __webpack_public_path__ + "static/media/fill_outline_pattern.vertex.61ec8a6b.glsl";